import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import Site from "@/Site";
import { redirectMap } from "@/marketing/seo/priorityContent";
import "@/index.css";

const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
const redirect = redirectMap.find(([source]) => source === currentPath);

if (window.location.hostname === "www.raqoz.com") {
  window.location.replace(`https://raqoz.com${window.location.pathname}${window.location.search}${window.location.hash}`);
} else if (redirect) {
  const [, destination] = redirect;
  window.location.replace(`${destination}${window.location.search}${window.location.hash}`);
} else {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <Site />
    </StrictMode>,
  );
}
